import React, { Component } from "react";
import { t, getLanguage } from "../../Helper/i18n";

// CSS
import "../../styles/newDesign.scss";
import "./Live.scss";

// Components
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

// Helper
import { resolveTenant, isLoggedIn, listMyMeetings } from "../../Helper/Api";
import { pushState, enablePush, disablePush, needsHomeScreen } from "../../Helper/push";
import Toast from "../../components/Toast/Toast";

const properties = require("../../properties.json");

function when(iso) {
  return new Date(iso).toLocaleString(getLanguage() === "en" ? "en-GB" : "ar-EG", { weekday: "long", day: "numeric", month: "long", hour: "numeric", minute: "2-digit" });
}

// The student's live sessions: what's coming up from their teacher, and a join button once the teacher starts.
class Live extends Component {
  state = { tenant: null, notFound: false, meetings: null, error: null, push: null, pushBusy: false, pushError: null };

  componentDidMount() {
    if (!isLoggedIn()) {
      window.location.href = "/sign-in";
      return;
    }
    resolveTenant()
      .then((tenant) => {
        document.title = properties.site_name + " - " + t("liveTitle");
        this.setState({ tenant });
        this.load();
        this.timer = setInterval(this.load, 30000);
        pushState().then((push) => this.setState({ push })).catch(() => this.setState({ push: "unsupported" }));
      })
      .catch(() => this.setState({ notFound: true }));
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  load = () => {
    listMyMeetings()
      .then((meetings) => this.setState({ meetings: meetings || [], error: null }))
      .catch((e) => this.setState({ meetings: this.state.meetings || [], error: e.message }));
  };

  togglePush = () => {
    const on = this.state.push === "on";
    this.setState({ pushBusy: true, pushError: null });
    (on ? disablePush() : enablePush())
      .then((push) => this.setState({ push, pushBusy: false }))
      .catch((e) => this.setState({ pushBusy: false, push: e.message === "blocked" ? "blocked" : this.state.push,
        pushError: e.message === "blocked" ? null : e.message }));
  };

  renderReminders() {
    const { push, pushBusy, pushError } = this.state;
    if (push === null) return null;
    let text;
    let action = null;
    if (push === "on") {
      text = t("liveRemindersOn");
      action = t("liveTurnOff");
    } else if (push === "blocked") {
      text = t("liveBlocked");
    } else if (push === "unsupported") {
      text = needsHomeScreen()
        ? t("liveIos")
        : t("liveUnsupported");
    } else {
      text = t("liveRemindersOff");
      action = "🔔 " + t("liveTurnOn");
    }
    return (
      <div className={"lv-reminder" + (push === "on" ? " on" : "")}>
        <span>{text}</span>
        {action && <button type="button" className="lv-remind-btn" disabled={pushBusy} onClick={this.togglePush}>{pushBusy ? "..." : action}</button>}
        <Toast msg={pushError} type="error" />
      </div>
    );
  }

  render() {
    const { tenant, notFound, meetings, error } = this.state;
    if (notFound) {
      return (
        <div className="page">
          <div className="container text-center">
            <p>{t("notFound")}</p>
          </div>
        </div>
      );
    }
    if (!tenant) return null;

    return (
      <>
        <Header tenant={tenant} />
        <div className="nd-page">
          <div className="nd-hero">
            <div className="nd-wrap">
              <div className="nd-eyebrow">{t("live")}</div>
              <h1 className="nd-title">{t("liveTitle")}</h1>
              <p>{t("liveLead")}</p>
            </div>
          </div>
          <div className="nd-section nd-wrap">
            {this.renderReminders()}
            <Toast msg={error} type="warning" />
            {meetings === null && <p className="lv-muted">{t("loading")}</p>}
            {meetings && meetings.length === 0 && <p className="lv-muted">{t("noLive")}</p>}
            <div className="lv-list">
              {(meetings || []).map((m) => (
                <div className={"lv-card" + (m.status === "LIVE" ? " live" : "")} key={m.id}>
                  <div className="lv-info">
                    <h3>
                      {m.title} {m.status === "LIVE" && <span className="lv-badge">{t("liveNow")}</span>}
                    </h3>
                    <div className="lv-meta">
                      <span>{when(m.startAt)}</span>
                      <span>{t("minutes", { n: Math.round((new Date(m.endAt) - new Date(m.startAt)) / 60000) })}</span>
                      {m.courseTitle && <span>{m.courseTitle}</span>}
                    </div>
                  </div>
                  <a className={"lv-join" + (m.actionable ? "" : " disabled")} href={m.actionable ? `/live/${m.id}` : undefined}
                     aria-disabled={!m.actionable}>
                    {m.actionable ? t("joinNow") : t("notStarted")}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
        <Footer tenant={tenant} />
      </>
    );
  }
}

export default Live;
